import { Autocomplete, Box, TextField } from "@mui/material";
import React from "react";
import { countries } from "src/utils/country";

export default function SelectCountry({ selectedCountry, onChange }) {
  return (
    <Autocomplete
      id="country-select-demo"
      options={countries}
      autoHighlight
      value={selectedCountry}
      onChange={(event, newValue) => onChange(newValue)}
      getOptionLabel={(option) => option.label}
      renderOption={(props, option) => (
        <Box
          component="li"
          sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
          {...props}
        >
          <img
            loading="lazy"
            width="20"
            src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
            srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
            alt=""
          />
          {option.label} ({option.code}) +{option.phone}
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Choose a country"
          inputProps={{
            ...params.inputProps,
            autoComplete: "new-password", // disable autocomplete and autofill
          }}
        />
      )}
    />
  );
}
